import script from "./ffswiper.vue?vue&type=script&setup=true&lang=js"
export * from "./ffswiper.vue?vue&type=script&setup=true&lang=js"

import "./ffswiper.vue?vue&type=style&index=0&id=7b81c942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b81c942"]])

export default __exports__